<div class="card">
  <div class="card-header d-flex justify-content-between align-items-center">
    <span>{{ heading }}</span>
    @if (!additions && !removals) {
      <span class="text-muted small">No Changes</span>
    } @else {
      <span class="small">
        @if (removals) {
          <span class="me-2 text-danger">{{ removals }} removal{{ removals === 1 ? '' : 's' }}</span>
        }
        @if (additions) {
          <span class="text-success">{{ additions }} addition{{ additions === 1 ? '' : 's' }}</span>
        }
      </span>
    }
  </div>
  <div class="card-body">
    @if (hasContent) {
      <div class="d-flex gap-3 mb-1">
        <div class="text-muted small" style="flex: 1 1 0; min-width: 0">{{ originalLabel }}</div>
        <div class="text-muted small" style="flex: 1 1 0; min-width: 0">{{ modifiedLabel }}</div>
      </div>
      <div class="d-flex gap-3">
        <div class="diff-original" [style.white-space]="preformatted ? 'pre-wrap' : null" [innerHTML]="originalDiffHtml"></div>
        <div class="diff-modified" [style.white-space]="preformatted ? 'pre-wrap' : null" [innerHTML]="modifiedDiffHtml"></div>
      </div>
    } @else {
      <div class="text-muted text-center">No content</div>
    }
  </div>
</div>
